// /c:/Users/Usuario/Documents/ELIAS/radio-player/src/data/fetchs/fetchDailyVerse.js

async function fetchDailyVerse() {
    try {
        const response = await fetch('https://embajadoresdelgranrey.com/wp-json/wp/v2/posts?categories=13&_embed');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const posts = await response.json();
        const post = posts[0];
        if (!post) {
            throw new Error('No post found');
        }

        const title = post.title.rendered;
        const content = post.content.rendered;
        let featuredImage = null;

        if (post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0]) {
            featuredImage = post._embedded['wp:featuredmedia'][0].source_url;
        }

        return { title, content, featuredImage };
    } catch (error) {
        console.error('Error fetching daily verse:', error);
        throw error;
    }
}

export default fetchDailyVerse;